import React from 'react';
import PropTypes from 'prop-types';

import StaticBackdrop from './StaticBackdrop';
import Svg from './Svg';

import '../styles/prompt.scss';

const Prompt = ({ children }) => (
  <StaticBackdrop>
    <div className="prompt">
      <div className="prompt-header">
        <Svg icon="ramp" />
        <Svg icon="license-vendor" />
        <Svg icon="bow" />
        <Svg icon="marina" />
        <Svg icon="bait-shop" />
      </div>
      {children}
    </div>
  </StaticBackdrop>
);

Prompt.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Prompt;
